<template>
    <img :src="src" alt="truck" :width="width" :height="height">
</template>

<script>
    export default {
        props: [
            'src',
            'width',
            'height'
        ]
    }
</script>
